import React, { useState } from 'react';

import { RadioButton } from '@sravni/react-design-system';

import { FORM_TYPE } from '../../../constants/proposal';
import { IShareArticleForm, ShareArticleForm } from '../ShareArticleForm';
import { IShareIdeaForm, ShareIdeaForm } from '../ShareIdeaForm';

import styles from './styles.module.scss';

interface Props {
  onSubmit?: (type: FORM_TYPE, form: IShareArticleForm | IShareIdeaForm) => void;
}

const TABS = [
  { label: 'Есть идея', value: FORM_TYPE.IDEA },
  { label: 'Напишу сам', value: FORM_TYPE.ARTICLE },
];

export const Forms: React.FC<Props> = ({ onSubmit }) => {
  const [currentType, setType] = useState(FORM_TYPE.IDEA);

  let Component = ShareIdeaForm;

  if (currentType === FORM_TYPE.ARTICLE) {
    Component = ShareArticleForm;
  }

  return (
    <>
      <RadioButton
        defaultValue={FORM_TYPE.IDEA}
        className={styles.radio}
        options={TABS}
        onChange={(value: number) => setType(value)}
      />
      <Component onSubmit={(form) => onSubmit?.(currentType, form)} />
    </>
  );
};
